const styles = theme => ({
  ...theme.classes,
  container: {
    margin: '0 auto',
    width: 1200,
    padding: '0',
    height: '100vh',
    '@media (max-width:1240px)': {
      width: '100%',
    },
  },
  content: {
    background: theme.palette.common.white,
    position: 'relative',
    height: 'calc(100% - 68px)',
    overflowY: 'auto',
    padding: '34px 40px 0',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    '&::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.2)',
      borderRadius: 10,
      backgroundColor: '#FEFEFE',
    },
    '&::-webkit-scrollbar': {
      width: 10,
      backgroundColor: '#FEFEFE',
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 10,
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,.2)',
      backgroundColor: '#F3F3F3',
    },
    '@media (max-width:1240px)': {
      padding: 0,
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
    },
  },
  content2: {
    marginTop: -29,
    '@media (max-width:1240px)': {
      marginTop: 0,
    },
  },
});

export default styles;
